function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.875 8.7a.417.417 0 010 .592l-.583.583a.417.417 0 01-.592 0L5 6.175l-3.7 3.7a.417.417 0 01-.592 0l-.583-.583a.417.417 0 010-.592l3.7-3.7-3.7-3.7a.417.417 0 010-.592L.708.125a.417.417 0 01.592 0l3.7 3.7 3.7-3.7a.417.417 0 01.592 0l.583.583a.417.417 0 010 .592L6.175 5l3.7 3.7z"
});

var SvgDismiss = function SvgDismiss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgDismiss;